import React, { Component } from 'react';
import { HEADINGS_DROPDOWN_TYPE, mergeStyles } from 'wix-rich-content-common';
import { HEADING_TYPE_TO_ELEMENT } from '../constants.js';
import { hasBlockType, RichUtils, FORMATTING_BUTTONS, EditorState, InlineToolbarButton, ClickOutside } from 'wix-rich-content-editor-common';
import Modal from 'react-modal';
import { s as styleInject, H as HeadingsDropDownPanel } from '../HeadingPanel-e286797a.js';
import classNames from 'classnames';
import 'prop-types';
import 'wix-rich-content-plugin-commons';

var css_248z = "._9HVmS{bottom:auto;position:fixed}[dir] ._9HVmS{padding:0}[dir=ltr] ._9HVmS{right:auto}[dir=rtl] ._9HVmS{left:auto}[dir] .EEHRY{border-radius:unset;box-shadow:unset}.zg9wy{bottom:0;position:fixed;top:0;z-index:40}[dir] .zg9wy{background-color:transparent}[dir=ltr] .zg9wy{left:0;right:0}[dir=rtl] .zg9wy{left:0;right:0}[dir] .Up69Q{background-color:rgba(0,0,0,.2)}.c71d-{position:relative}[dir=ltr] .c71d-{margin-right:10px}[dir=rtl] .c71d-{margin-left:10px}.c71d- .rZBzQ{position:absolute;top:50px}[dir] .c71d- .rZBzQ{background:#fff}[dir] .c71d- .rZBzQ button{background-color:transparent}";
var styles = {"headingsModal":"_9HVmS","headingsModal_mobile":"EEHRY","headingsModalOverlay":"zg9wy","headingsModalOverlay_mobile":"Up69Q","headingPopup_button":"c71d-","headingPopup":"rZBzQ"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class HeadingButton extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = null;
    this.findCurrentHeading = () => {
      const currentEditorState = this.props.getEditorState();
      const selection = currentEditorState.getSelection();
      const headingType = currentEditorState.getCurrentContent().blockMap.get(selection.anchorKey).getType();
      const currentHeading = HEADING_TYPE_TO_ELEMENT[headingType] || "P";
      this.setState({ currentHeading });
    };
    this.openPanel = () => {
      var _a, _b;
      this.currentEditorState = this.oldEditorState = this.props.getEditorState();
      this.selection = this.oldEditorState.getSelection();
      const { bottom, left } = this.buttonRef.getBoundingClientRect();
      (_b = (_a = this.props).setKeepOpen) == null ? void 0 : _b.call(_a, true);
      this.setState({ isPanelOpen: true, panelLeft: left - 15, panelTop: bottom });
    };
    this.closePanel = () => {
      var _a, _b;
      this.setState({ isPanelOpen: false });
      (_b = (_a = this.props).setKeepOpen) == null ? void 0 : _b.call(_a, false);
    };
    this.updateHeading = (type, element) => {
      var _a, _b, _c;
      const { setEditorState, getEditorState, helpers } = this.props;
      const editorState = getEditorState();
      const isAddEvent = !hasBlockType(type, editorState);
      const newEditorState = RichUtils.toggleBlockType(editorState, type);
      (_a = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _a.call(helpers, {
        pluginId: HEADINGS_DROPDOWN_TYPE,
        buttonName: FORMATTING_BUTTONS.HEADINGS,
        value: type
      });
      isAddEvent && ((_b = helpers == null ? void 0 : helpers.onPluginAdd) == null ? void 0 : _b.call(helpers, type, "FormattingToolbar"));
      setEditorState(EditorState.forceSelection(newEditorState, this.selection));
      isAddEvent && ((_c = helpers == null ? void 0 : helpers.onPluginAddSuccess) == null ? void 0 : _c.call(helpers, type, "FormattingToolbar"));
      this.currentEditorState = newEditorState;
      this.setState({ currentHeading: element });
    };
    this.translateHeading = (option = "") => {
      const { t } = this.props;
      return option.length === 1 ? t("FormattingToolbar_TextStyle_Paragraph") : t("FormattingToolbar_TextStyle_Heading", { number: option.slice(-1) });
    };
    this.fixEllipsis = (text = "") => {
      if (text.length > 10) {
        const number = text.slice(-1);
        if (typeof number === "number") {
          return text.slice(0, 5) + "..." + number;
        } else {
          return text.slice(0, 6) + "...";
        }
      }
      return text;
    };
    this.save = (type, element) => {
      this.closePanel();
      type ? this.updateHeading(type, element) : this.props.setEditorState(
        EditorState.forceSelection(this.currentEditorState, this.selection)
      );
    };
    this.state = {
      showPanel: false,
      currentHeading: "P"
    };
    this.styles = mergeStyles({ styles, theme: props.theme });
    this.dataHookText = "headingsDropdownButton";
  }
  componentWillReceiveProps() {
    this.findCurrentHeading();
  }
  static getModalParent() {
    return document.querySelector(".DraftEditor-root").parentNode;
  }
  render() {
    const { theme, helpers, isMobile, t, tabIndex, toolbarName, customHeadings, inlinePopups } = this.props;
    const tooltipText = t("FormattingToolbar_TextStyleButton_Tooltip");
    const { isPanelOpen, panelTop, panelLeft, currentHeading } = this.state;
    const { styles: styles2 } = this;
    const modalStyle = isMobile ? { left: 0, bottom: 0, right: 0 } : {
      top: panelTop,
      left: panelLeft
    };
    const buttonContent = this.fixEllipsis(this.translateHeading(currentHeading));
    if (isMobile || toolbarName !== "StaticTextToolbar" || !inlinePopups) {
      return /* @__PURE__ */ React.createElement(
        InlineToolbarButton,
        {
          onClick: this.openPanel,
          isActive: isPanelOpen,
          helpers,
          theme,
          isMobile,
          tooltipText,
          dataHook: this.dataHookText,
          formattingButtonName: FORMATTING_BUTTONS.HEADINGS,
          tabIndex,
          buttonContent,
          showArrowIcon: true,
          pluginType: HEADINGS_DROPDOWN_TYPE,
          ref: (ref) => this.buttonRef = ref
        },
        /* @__PURE__ */ React.createElement(
          Modal,
          {
            isOpen: !!isPanelOpen,
            onRequestClose: () => this.save(),
            className: classNames(styles2.headingsModal, {
              [styles2.headingsModal_mobile]: isMobile
            }),
            overlayClassName: classNames(styles2.headingsModalOverlay, {
              [styles2.headingsModalOverlay_mobile]: isMobile
            }),
            parentSelector: HeadingButton.getModalParent,
            style: {
              content: modalStyle
            },
            ariaHideApp: false
          },
          /* @__PURE__ */ React.createElement(
            HeadingsDropDownPanel,
            __spreadValues({
              customHeadingsOptions: customHeadings,
              heading: currentHeading,
              onSave: this.save,
              translateHeading: this.translateHeading
            }, this.props)
          )
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: styles2.headingPopup_button }, /* @__PURE__ */ React.createElement(
        InlineToolbarButton,
        {
          onClick: this.openPanel,
          isActive: isPanelOpen,
          helpers,
          theme,
          isMobile,
          tooltipText,
          dataHook: this.dataHookText,
          formattingButtonName: FORMATTING_BUTTONS.HEADINGS,
          tabIndex,
          buttonContent,
          showArrowIcon: true,
          pluginType: HEADINGS_DROPDOWN_TYPE,
          ref: (ref) => this.buttonRef = ref
        },
        isPanelOpen && /* @__PURE__ */ React.createElement("div", { className: styles2.headingPopup }, /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside: () => this.save() }, /* @__PURE__ */ React.createElement(
          HeadingsDropDownPanel,
          __spreadValues({
            customHeadingsOptions: customHeadings,
            heading: currentHeading,
            onSave: this.save,
            translateHeading: this.translateHeading
          }, this.props)
        )))
      ));
    }
  }
}

export { HeadingButton as default };
//# sourceMappingURL=HeadingButton.js.map
